module.exports = __webpack_public_path__ + "static/Sonyax4a-eb4890a356f9407d27861ef99713f566.png";